export namespace ResetPasswordRecoveryPasswordInitNamespace {
  export interface IN {
    login: string;
    recaptchaToken: string;
  }

  export class OUT {
    // requestKey: string = '';
    // init(input: ResetPasswordRecoveryPasswordInitApiNamespace.OUT) {
    //   // this.requestKey = input.recoverPasswordKey;
    //   return this;
    // }
  }
}
